import React from "react";
import { Badge } from "src/components/ui/Badge";
import { Input } from "src/components/ui/Input";
import { Button } from "src/components/ui/Button";
import { footerLinks } from "src/utils/constants";
import maskGroupImage from "src/assets/maskGroup.png";

import "./CallToActionSection.scss";

const CallToActionSection = () => {
  return (
    <section className="call-to-action-section">
      <div className="call-to-action-section__container">
        <div
          className="call-to-action-section__banner"
          style={{ backgroundImage: `url(${maskGroupImage})` }}
        >
          <div className="call-to-action-section__content">
            <h2 className="call-to-action-section__heading">
              An enterprise template to ramp up your company website
            </h2>

            <div className="call-to-action-section__form">
              <div className="call-to-action-section__input-container">
                <Input
                  type="email"
                  placeholder="Your email address"
                  className="call-to-action-section__input"
                />
              </div>

              <Button
                variant="themed-outline"
                className="call-to-action-section__button"
              >
                <span className="call-to-action-section__button-text">
                  Start now
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <footer className="call-to-action-section__footer">
        <div className="call-to-action-section__footer-container">
          <div className="call-to-action-section__footer-content">
            <div className="call-to-action-section__company">
              <div className="call-to-action-section__logo-container">
                <div className="call-to-action-section__logo">
                  <div className="call-to-action-section__logo-bottom" />
                  <div className="call-to-action-section__logo-top" />
                </div>
                <span className="call-to-action-section__brand">Boldo</span>
              </div>

              <p className="call-to-action-section__company-description">
                Social media validation business model canvas graphical user
                interface launch party creative facebook iPad twitter.
              </p>

              <p className="call-to-action-section__copyright">
                All rights reserved.
              </p>
            </div>

            <div className="call-to-action-section__nav-container">
              <nav className="call-to-action-section__nav">
                <h3 className="call-to-action-section__nav-title">Landings</h3>
                <ul className="call-to-action-section__nav-list">
                  {footerLinks.landings.map(({ href, label }, index) => (
                    <li
                      key={index}
                      className="call-to-action-section__nav-item"
                    >
                      <a
                        href={href}
                        className="call-to-action-section__nav-link"
                      >
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>

              <nav className="call-to-action-section__nav">
                <h3 className="call-to-action-section__nav-title">Company</h3>
                <ul className="call-to-action-section__nav-list">
                  {footerLinks.company.map(({ href, label }, index) => (
                    <li
                      key={index}
                      className="call-to-action-section__nav-item"
                    >
                      <a
                        href={href}
                        className="call-to-action-section__nav-link"
                      >
                        {label}
                      </a>
                      {label === "Careers" && (
                        <Badge className="call-to-action-section__badge">
                          <span className="call-to-action-section__badge-text">
                            Hiring!
                          </span>
                        </Badge>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>

              <nav className="call-to-action-section__nav">
                <h3 className="call-to-action-section__nav-title">Resources</h3>
                <ul className="call-to-action-section__nav-list">
                  {footerLinks.resources.map((link, index) => (
                    <li
                      key={index}
                      className="call-to-action-section__nav-item"
                    >
                      <a
                        href={link.href}
                        className="call-to-action-section__nav-link"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default CallToActionSection;
